const getLocation = function(locationName) {
  const filtered = [
    {
      address: /grizzly peak/i,
      location: {
        lat: 37.8820350,
        lng: -122.2338080
      }
    },
    {
      address: /bonsai rock/i,
      location: {
        lat: 39.1848440,
        lng: -119.927727
      }
    },
    {
      address: /bowling ball beach/i,
      location: {
        lat: 38.8709880,
        lng: -123.6580160
      }
    },
    {
      address: /drake'?s beach/i,
      location: {
        lat: 38.0405200,
        lng: -122.8588410
      }
    },
    {
      address: /tam/i,
      location: {
        lat: 37.9237680,
        lng: -122.5964170
      }
    },
    {
      address: /ggb|golden gate|kirby|rodeo|marshall/i,
      location: {
        lat: 37.8199290,
        lng: -122.4782550
      }
    },
    {
      address: /bay bridge/i,
      location: {
        lat: 37.8074330,
        lng: -122.3666440
      }
    },
    {
      address: /tunnel view|yosemite/i,
      location: {
        lat: 37.7124800,
        lng: -119.7049780
      }
    },
    {
      address: /bean hollow/i,
      location: {
        lat: 37.2304754,
        lng: -122.4121035
      }
    },
    {
      address: /(?:4|four) mile/i,
      location: {
        lat: 36.9646667,
        lng: -122.1201667
      }
    },
    {
      address: /walton|natural bridges|^sc$/i,
      location: {
        lat: 36.9606430,
        lng: -122.0021780
      }
    },
    {
      address: /asilomar/i,
      location: {
        lat: 36.6206635,
        lng: -121.9418817
      }
    },
    {
      address: /mobius arch|alabama hills/i,
      location: {
        lat: 36.6120830,
        lng: -118.1255420
      }
    },
    {
      address: /mesquite (?:sand )?dunes/i,
      location: {
        lat: 36.6063560,
        lng: -117.1461130
      }
    },
    {
      address: /garrapata/i,
      location: {
        lat: 36.4598120,
        lng: -121.9266400
      }
    },
    {
      address: /el matador|malibu/i,
      location: {
        lat: 34.0391130,
        lng: -118.8759410
      }
    },
    {
      address: /bixby bridge/i,
      location: {
        lat: 36.3721971,
        lng: -121.9021213
      }
    },
    {
      address: /eastern sierra/i,
      location: {
        lat: 37.3614940,
        lng: -118.3961530
      }
    },
    {
      address: /calla lilies/i,
      location: {
        lat: 36.4598120,
        lng: -121.9266400
      }
    },
    {
      address: /^la$|socal/i,
      location: {
        lat: 34.069103,
        lng: -118.445235
      }
    },
    {
      address: /hawk hill/i,
      location: {
        lat: 37.8276750,
        lng: -122.4998880
      }
    },
    {
      address: /pigeon point/i,
      location: {
        lat: 37.1821680,
        lng: -122.3934280
      }
    },
    {
      address: /russian ridge|skyline/i,
      location: {
        lat: 37.3210540,
        lng: -122.2019810
      }
    },
    {
      address: /baker beach/i,
      location: {
        lat: 37.8199290,
        lng: -122.4782550
      }
    },
    {
      address: /land'?s end|sutro|mile rock/i,
      location: {
        lat: 37.7803674,
        lng: -122.5141675
      }
    },
    {
      address: /martin'?s beach/i,
      location: {
        lat: 37.3738362,
        lng: -122.4088311
      }
    },
    {
      address: /davenport/i,
      location: {
        lat: 37.0131760,
        lng: -122.1969930
      }
    },
    {
      address: /sunflowers|^sac$/i,
      location: {
        lat: 38.5778290,
        lng: -121.4941250
      }
    },
    {
      address: /sonoma coast|jenner/i,
      location: {
        lat: 38.4258910,
        lng: -123.1163190
      }
    }
  ].filter(item => locationName.match(item.address)).map(item => item.location);

  console.log(filtered); // eslint-disable-line no-console

  return filtered[0];
};

export default {
  getLocation: getLocation
};

/*
console.log(getLocation('Grizzly Peak, CA'));
console.log(getLocation('bonsai rock tahoe'));
console.log(getLocation('bowling Ball beach'));
console.log(getLocation('Drake\'s beach'));
console.log(getLocation('Drakes beach'));
console.log(getLocation('tam'));
console.log(getLocation('Marshall\'s Beach'));
console.log(getLocation('Rodeo'));
console.log(getLocation('Kirby Cove'));
console.log(getLocation('Golden Gate Bridge'));
console.log(getLocation('bay bridge sf'));
console.log(getLocation('tunnel view'));
console.log(getLocation('yosemite village'));
console.log(getLocation('bean hollow state park'));
console.log(getLocation('4 mile'));
console.log(getLocation('FOUR mile'));
console.log(getLocation('walton lighthouse'));
console.log(getLocation('natural bridges'));
console.log(getLocation('sc'));
console.log(getLocation('asilomar'));
console.log(getLocation('mobius arch ca'));
console.log(getLocation('alabama hills'));
console.log(getLocation('mesquite dunes'));
console.log(getLocation('mesquite sand dunes'));
console.log(getLocation('garrapata big sur'));
console.log(getLocation('malibu'));
console.log(getLocation('bixby bridge'));
console.log(getLocation('eastern sierra'));
console.log(getLocation('big sur calla lilies'));
console.log(getLocation('LA'));
console.log(getLocation('SoCal'));
console.log(getLocation('Hawk Hill GGB'));
console.log(getLocation('Pigeon Point Lighthouse'));
console.log(getLocation('Skyline'));
console.log(getLocation('lands end'));
console.log(getLocation('Land\'s end'));
console.log(getLocation('Sutro baths'));
console.log(getLocation('Mile Rock'));
console.log(getLocation('martin\'s beach'));
console.log(getLocation('Martins Beach'));
console.log(getLocation('Davenport'));
console.log(getLocation('sunflowers'));
console.log(getLocation('Sac'));
console.log(getLocation('Jenner'));
console.log(getLocation('Sonoma coast'));
*/
